import { Text, TextProps } from "@chakra-ui/react";
import React, { useMemo } from "react";

type Props = TextProps & {
  children: string;
  noWrap?: boolean;
};

/**
 * A special version of Text that also allows for word breaking on underscores.
 */
export const TextWordBreak = ({ children, noWrap, ...rest }: Props) => {
  const words = useMemo(() => children.split("_"), [children]);
  if (noWrap) return <Text {...rest}>{children}</Text>;

  return (
    <Text overflowWrap="anywhere" {...rest}>
      {words.map((word, i) => (
        <React.Fragment key={i}>
          {word}
          {i < words.length - 1 && "_"}
          {i < words.length - 1 && <wbr />}
        </React.Fragment>
      ))}
    </Text>
  );
};
